var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_vm._m(0), _vm._v(" "), _c('illustration', {
    staticClass: "hidden xl:block absolute right-5 xl:right-10 -top-8 w-60 xl:w-72",
    attrs: {
      "name": "fiche_de_poste"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-15 align-middle shadow rounded-lg border-b border-gray-200 bg-white pb-10 min-h-halfscreen max-w-full"
  }, [_vm.allowed ? _c('router-view') : _vm._e(), _vm._v(" "), !_vm.allowed ? _c('page-not-allowed') : _vm._e()], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-12"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("\n        Recherche de compétences\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 max-w-3/4 2xl:max-w-11/12"
  }, [_vm._v("\n        Vous pouvez rechercher une compétence personnelle, socio-professionnelle ou professionnelle sur l’ensemble des passeports.\n      ")])]);

}]

export { render, staticRenderFns }